import { createContext, useContext } from 'react';
import { DocumentModelMetadata } from 'types/dynamic-forms/DocumentModelMetadata';
import { DataSources } from 'types/dynamic-forms/DataSources';
import { DocumentProperty } from 'types/dynamic-forms/DocumentProperty';
import { DocumentDiff } from 'types/dynamic-forms/DocumentDiff';
import { CompareSide } from '../diffHighlight';

export interface ComparisonSideData {
  data: Record<string, unknown>;
  metadata: DocumentModelMetadata;
  dataSources: DataSources;
  properties: DocumentProperty[];
}

export interface ComparisonContextValue {
  left: ComparisonSideData;
  right: ComparisonSideData;
  diff: DocumentDiff;
  /** Which column is currently being rendered (each version is its own card). */
  side: CompareSide;
}

export const ComparisonContext = createContext<ComparisonContextValue | null>(null);

export function useComparisonContext(): ComparisonContextValue {
  const context = useContext(ComparisonContext);
  if (!context) {
    throw new Error('useComparisonContext must be used within a ComparisonContext.Provider');
  }
  return context;
}
